export default "__VITE_ASSET__2b_BDa4z__"